export abstract class ReduceHelperObject<T> {
  data: T;
  abstract add(key: string, value: any): ReduceHelperObject<T>;

  constructor(data: T) {
    this.data = data;
  }

  toObject() {
    return Object.entries(this.data)
      .reduce(
        (obj, [key, value]) => {
          obj[key] = value;
          return obj;
        },
        {},
      );
  }

  toArray() {
    return Object.values(this.data);
  }

  toEntries() {
    return Object.entries(this.data);
  }

  * [Symbol.iterator]() {
    yield* this.toEntries();
  }
}

export class KeyByObject<U> extends ReduceHelperObject<{[key: string]: U}> {
  private dontReplace;

  constructor(dontReplace = false) {
    super({});
    this.dontReplace = dontReplace;
  }

  add(key: string, value: U): KeyByObject<U> {
    if (this.dontReplace && Object.prototype.hasOwnProperty.call(this.data, key)) return this as KeyByObject<U>;
    this.data[key] = value;
    return this as KeyByObject<U>;
  }
}

export class GroupByObject<U> extends ReduceHelperObject<{[key: string]: U[]}> {
  private unique;

  constructor(unique = false) {
    super({});
    this.unique = unique;
  }

  add(key: string, value: U): GroupByObject<U> {
    if (!this.data[key]) this.data[key] = [];
    if (this.unique && this.data[key].includes(value)) return this as GroupByObject<U>;
    this.data[key].push(value);
    return this as GroupByObject<U>;
  }
}
